export default __webpack_public_path__ + "static/media/Hair_6_M_C2.808e04cc.svg";